// stores/customerStore.ts
import { create } from 'zustand';

interface Customer {
  id: string;
  name: string;
  cin: string;
  city?:string
}

interface CustomerState {
  customer: Customer | null;
  setCustomer: (customer: Customer) => void;
  clearCustomer: () => void;
}

export const useCustomerStore = create<CustomerState>((set) => ({
  customer: null,
  setCustomer: (customer) => set({ customer }),
  clearCustomer: () => set({ customer: null }),
}));
